export default __webpack_public_path__ + "static/media/interactive.2b5ad339.png";